// import React from "react";
// import MatchComparisonProgressBar from "./MatchComparisonProgressBar";
// import { useSelector } from "react-redux";

// const MatchComparison = ({ teamStatistics }) => {
//   const { lang } = useSelector((state) => state.langSlice);
//   return (
//     <>
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamTotalShotsPer}
//         percentage2={teamStatistics?.awayTeamTotalShotsPer}
//         value1={
//           teamStatistics?.homeTeamTotalShots != null
//             ? teamStatistics?.homeTeamTotalShots
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamTotalShots != null
//             ? teamStatistics?.awayTeamTotalShots
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Total Shots"
//             : lang == "spanish"
//             ? "Disparos totales"
//             : lang == "french"
//             ? "Nombre total de tirs"
//             : lang == "arabic"
//             ? "مجموع الطلقات"
//             : "Total Shots"
//         }
//       />
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamShotsOnGoalPer}
//         percentage2={teamStatistics?.awayTeamShotsOnGoalPer}
//         value1={
//           teamStatistics?.homeTeamShotsOnGoal != null
//             ? teamStatistics?.homeTeamShotsOnGoal
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamShotsOnGoal != null
//             ? teamStatistics?.awayTeamShotsOnGoal
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Shots On Goal"
//             : lang == "spanish"
//             ? "Tiros a puerta"
//             : lang == "french"
//             ? "Tirs au but"
//             : lang == "arabic"
//             ? "تسديدة على المرمى"
//             : "Shots On Goal"
//         }
//       />
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamShotsOffGoalPer}
//         percentage2={teamStatistics?.awayTeamShotsOffGoalPer}
//         value1={
//           teamStatistics?.homeTeamShotsOffGoal != null
//             ? teamStatistics?.homeTeamShotsOffGoal
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamShotsOffGoal != null
//             ? teamStatistics?.awayTeamShotsOffGoal
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Shots Off Goal"
//             : lang == "spanish"
//             ? "Tiros fuera de portería"
//             : lang == "french"
//             ? "Tirs hors but"
//             : lang == "arabic"
//             ? "التسديدات خارج المرمى"
//             : "Shots Off Goal"
//         }
//       />
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamFoulsPer}
//         percentage2={teamStatistics?.awayTeamFoulsPer}
//         value1={
//           teamStatistics?.homeTeamFouls != null
//             ? teamStatistics?.homeTeamFouls
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamFouls != null
//             ? teamStatistics?.awayTeamFouls
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Fouls"
//             : lang == "spanish"
//             ? "Faltas"
//             : lang == "french"
//             ? "Fautes"
//             : lang == "arabic"
//             ? "الأخطاء"
//             : "Fouls"
//         }
//       />
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamCornerPer}
//         percentage2={teamStatistics?.awayTeamCornerPer}
//         value1={
//           teamStatistics?.homeTeamCorner != null
//             ? teamStatistics?.homeTeamCorner
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamCorner != null
//             ? teamStatistics?.awayTeamCorner
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Corner Kicks"
//             : lang == "spanish"
//             ? "Tiros de esquina"
//             : lang == "french"
//             ? "Coups de pied de coin"
//             : lang == "arabic"
//             ? "ركن الركلات"
//             : "Corner Kicks"
//         }
//       />
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamOffsidesPer}
//         percentage2={teamStatistics?.awayTeamOffsidesPer}
//         value1={
//           teamStatistics?.homeTeamOffsides != null
//             ? teamStatistics?.homeTeamOffsides
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamOffsides != null
//             ? teamStatistics?.awayTeamOffsides
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Offsides"
//             : lang == "spanish"
//             ? "Fueras de juego"
//             : lang == "french"
//             ? "Hors-jeu"
//             : lang == "arabic"
//             ? "التسلل"
//             : "Offsides"
//         }
//       />

//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamYellowCardPer}
//         percentage2={teamStatistics?.awayTeamYellowCardPer}
//         value1={
//           teamStatistics?.homeTeamYellowCard != null
//             ? teamStatistics?.homeTeamYellowCard
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamYellowCard != null
//             ? teamStatistics?.awayTeamYellowCard
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Yellow Cards"
//             : lang == "spanish"
//             ? "Tarjetas amarillas"
//             : lang == "french"
//             ? "Cartons jaunes"
//             : lang == "arabic"
//             ? "البطاقات الصفراء"
//             : "Yellow Cards"
//         }
//       />
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamRedCardPer}
//         percentage2={teamStatistics?.awayTeamRedCardPer}
//         value1={
//           teamStatistics?.homeTeamRedCard != null
//             ? teamStatistics?.homeTeamRedCard
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamRedCard != null
//             ? teamStatistics?.awayTeamRedCard
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Red Cards"
//             : lang == "spanish"
//             ? "Tarjetas rojas"
//             : lang == "french"
//             ? "Cartons rouges"
//             : lang == "arabic"
//             ? "البطاقات الحمراء"
//             : "Red Cards"
//         }
//       />
//       <MatchComparisonProgressBar
//         // percentage1={teamStatistics?.homeTeamPossession.replace("%", "")}
//         // percentage2={teamStatistics?.awayTeamPossession.replace("%", "")}

//         percentage1={teamStatistics?.homeTeamPossession?.replace("%", "") || 0}
// percentage2={teamStatistics?.awayTeamPossession?.replace("%", "") || 0}
//         value1={
//           teamStatistics?.homeTeamPossession != null
//             ? teamStatistics?.homeTeamPossession
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamPossession != null
//             ? teamStatistics?.awayTeamPossession
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Ball Possession"
//             : lang == "spanish"
//             ? "Posesión del balón"
//             : lang == "french"
//             ? "Possession de la balle"
//             : lang == "arabic"
//             ? "امتلاك الكرة"
//             : "Ball Possession"
//         }
//       />
//       <MatchComparisonProgressBar
//         percentage1={teamStatistics?.homeTeamPassesPer}
//         percentage2={teamStatistics?.awayTeamPassesPer}
//         value1={
//           teamStatistics?.homeTeamPasses != null
//             ? teamStatistics?.homeTeamPasses
//             : 0
//         }
//         value2={
//           teamStatistics?.awayTeamPasses != null
//             ? teamStatistics?.awayTeamPasses
//             : 0
//         }
//         name={
//           lang == "english"
//             ? "Passes"
//             : lang == "spanish"
//             ? "Pases"
//             : lang == "french"
//             ? "Laissez-passer"
//             : lang == "arabic"
//             ? "يمر، يمرر، اجتاز بنجاح"
//             : "Passes"
//         }
//       />
//     </>
//   );
// };

// export default MatchComparison;



import React from "react";
import MatchComparisonProgressBar from "./MatchComparisonProgressBar";
import { useSelector } from "react-redux";

const MatchComparison = ({
  teamStatistics,
  homeTeamStatistics,
  awayTeamStatistics,
}) => {
  const { lang } = useSelector((state) => state.langSlice);

  /*
   * Backend response:
   *
   * homeTeamStatistics = {
   *   team: {...},
   *   statistics: [
   *     { type: "Total Shots", value: 12 },
   *     { type: "Shots on Goal", value: 7 },
   *     ...
   *   ]
   * }
   *
   * awayTeamStatistics = same structure
   */

  const getStatValue = (team, type) => {
    const stat = team?.statistics?.find(
      (item) => item?.type?.toLowerCase() === type.toLowerCase()
    );

    return stat?.value ?? 0;
  };

  const getNumericValue = (value) => {
    if (value === null || value === undefined) {
      return 0;
    }

    if (typeof value === "string") {
      const numericValue = parseFloat(value.replace("%", ""));
      return Number.isNaN(numericValue) ? 0 : numericValue;
    }

    return Number(value) || 0;
  };

  const calculatePercentage = (value1, value2) => {
    const num1 = getNumericValue(value1);
    const num2 = getNumericValue(value2);

    const total = num1 + num2;

    if (total === 0) {
      return {
        percentage1: 0,
        percentage2: 0,
      };
    }

    return {
      percentage1: Math.round((num1 / total) * 100),
      percentage2: Math.round((num2 / total) * 100),
    };
  };

  // -----------------------------
  // Get statistics from API
  // -----------------------------

  const homeTotalShots = getStatValue(
    homeTeamStatistics,
    "Total Shots"
  );

  const awayTotalShots = getStatValue(
    awayTeamStatistics,
    "Total Shots"
  );

  const homeShotsOnGoal = getStatValue(
    homeTeamStatistics,
    "Shots on Goal"
  );

  const awayShotsOnGoal = getStatValue(
    awayTeamStatistics,
    "Shots on Goal"
  );

  const homeShotsOffGoal = getStatValue(
    homeTeamStatistics,
    "Shots off Goal"
  );

  const awayShotsOffGoal = getStatValue(
    awayTeamStatistics,
    "Shots off Goal"
  );

  const homeFouls = getStatValue(
    homeTeamStatistics,
    "Fouls"
  );

  const awayFouls = getStatValue(
    awayTeamStatistics,
    "Fouls"
  );

  const homeCorners = getStatValue(
    homeTeamStatistics,
    "Corner Kicks"
  );

  const awayCorners = getStatValue(
    awayTeamStatistics,
    "Corner Kicks"
  );

  const homeOffsides = getStatValue(
    homeTeamStatistics,
    "Offsides"
  );

  const awayOffsides = getStatValue(
    awayTeamStatistics,
    "Offsides"
  );

  const homeYellowCards = getStatValue(
    homeTeamStatistics,
    "Yellow Cards"
  );

  const awayYellowCards = getStatValue(
    awayTeamStatistics,
    "Yellow Cards"
  );

  const homeRedCards = getStatValue(
    homeTeamStatistics,
    "Red Cards"
  );

  const awayRedCards = getStatValue(
    awayTeamStatistics,
    "Red Cards"
  );

  const homePossession = getStatValue(
    homeTeamStatistics,
    "Ball Possession"
  );

  const awayPossession = getStatValue(
    awayTeamStatistics,
    "Ball Possession"
  );

  const homePasses = getStatValue(
    homeTeamStatistics,
    "Passes"
  );

  const awayPasses = getStatValue(
    awayTeamStatistics,
    "Passes"
  );

  // -----------------------------
  // Calculate percentages
  // -----------------------------

  const totalShotsPercentage = calculatePercentage(
    homeTotalShots,
    awayTotalShots
  );

  const shotsOnGoalPercentage = calculatePercentage(
    homeShotsOnGoal,
    awayShotsOnGoal
  );

  const shotsOffGoalPercentage = calculatePercentage(
    homeShotsOffGoal,
    awayShotsOffGoal
  );

  const foulsPercentage = calculatePercentage(
    homeFouls,
    awayFouls
  );

  const cornersPercentage = calculatePercentage(
    homeCorners,
    awayCorners
  );

  const offsidesPercentage = calculatePercentage(
    homeOffsides,
    awayOffsides
  );

  const yellowCardsPercentage = calculatePercentage(
    homeYellowCards,
    awayYellowCards
  );

  const redCardsPercentage = calculatePercentage(
    homeRedCards,
    awayRedCards
  );

  const possessionPercentage = calculatePercentage(
    homePossession,
    awayPossession
  );

  const passesPercentage = calculatePercentage(
    homePasses,
    awayPasses
  );

  return (
    <>
      {/* Total Shots */}
      <MatchComparisonProgressBar
        percentage1={totalShotsPercentage.percentage1}
        percentage2={totalShotsPercentage.percentage2}
        value1={homeTotalShots}
        value2={awayTotalShots}
        name={
          lang === "english"
            ? "Total Shots"
            : lang === "spanish"
            ? "Disparos totales"
            : lang === "french"
            ? "Nombre total de tirs"
            : lang === "arabic"
            ? "مجموع الطلقات"
            : "Total Shots"
        }
      />

      {/* Shots on Goal */}
      <MatchComparisonProgressBar
        percentage1={shotsOnGoalPercentage.percentage1}
        percentage2={shotsOnGoalPercentage.percentage2}
        value1={homeShotsOnGoal}
        value2={awayShotsOnGoal}
        name={
          lang === "english"
            ? "Shots On Goal"
            : lang === "spanish"
            ? "Tiros a puerta"
            : lang === "french"
            ? "Tirs au but"
            : lang === "arabic"
            ? "تسديدة على المرمى"
            : "Shots On Goal"
        }
      />

      {/* Shots off Goal */}
      <MatchComparisonProgressBar
        percentage1={shotsOffGoalPercentage.percentage1}
        percentage2={shotsOffGoalPercentage.percentage2}
        value1={homeShotsOffGoal}
        value2={awayShotsOffGoal}
        name={
          lang === "english"
            ? "Shots Off Goal"
            : lang === "spanish"
            ? "Tiros fuera de portería"
            : lang === "french"
            ? "Tirs hors but"
            : lang === "arabic"
            ? "التسديدات خارج المرمى"
            : "Shots Off Goal"
        }
      />

      {/* Fouls */}
      <MatchComparisonProgressBar
        percentage1={foulsPercentage.percentage1}
        percentage2={foulsPercentage.percentage2}
        value1={homeFouls}
        value2={awayFouls}
        name={
          lang === "english"
            ? "Fouls"
            : lang === "spanish"
            ? "Faltas"
            : lang === "french"
            ? "Fautes"
            : lang === "arabic"
            ? "الأخطاء"
            : "Fouls"
        }
      />

      {/* Corner Kicks */}
      <MatchComparisonProgressBar
        percentage1={cornersPercentage.percentage1}
        percentage2={cornersPercentage.percentage2}
        value1={homeCorners}
        value2={awayCorners}
        name={
          lang === "english"
            ? "Corner Kicks"
            : lang === "spanish"
            ? "Tiros de esquina"
            : lang === "french"
            ? "Coups de pied de coin"
            : lang === "arabic"
            ? "ركن الركلات"
            : "Corner Kicks"
        }
      />

      {/* Offsides */}
      <MatchComparisonProgressBar
        percentage1={offsidesPercentage.percentage1}
        percentage2={offsidesPercentage.percentage2}
        value1={homeOffsides}
        value2={awayOffsides}
        name={
          lang === "english"
            ? "Offsides"
            : lang === "spanish"
            ? "Fueras de juego"
            : lang === "french"
            ? "Hors-jeu"
            : lang === "arabic"
            ? "التسلل"
            : "Offsides"
        }
      />

      {/* Yellow Cards */}
      <MatchComparisonProgressBar
        percentage1={yellowCardsPercentage.percentage1}
        percentage2={yellowCardsPercentage.percentage2}
        value1={homeYellowCards}
        value2={awayYellowCards}
        name={
          lang === "english"
            ? "Yellow Cards"
            : lang === "spanish"
            ? "Tarjetas amarillas"
            : lang === "french"
            ? "Cartons jaunes"
            : lang === "arabic"
            ? "البطاقات الصفراء"
            : "Yellow Cards"
        }
      />

      {/* Red Cards */}
      <MatchComparisonProgressBar
        percentage1={redCardsPercentage.percentage1}
        percentage2={redCardsPercentage.percentage2}
        value1={homeRedCards}
        value2={awayRedCards}
        name={
          lang === "english"
            ? "Red Cards"
            : lang === "spanish"
            ? "Tarjetas rojas"
            : lang === "french"
            ? "Cartons rouges"
            : lang === "arabic"
            ? "البطاقات الحمراء"
            : "Red Cards"
        }
      />

      {/* Ball Possession */}
      <MatchComparisonProgressBar
        percentage1={getNumericValue(homePossession)}
        percentage2={getNumericValue(awayPossession)}
        value1={homePossession}
        value2={awayPossession}
        name={
          lang === "english"
            ? "Ball Possession"
            : lang === "spanish"
            ? "Posesión del balón"
            : lang === "french"
            ? "Possession de la balle"
            : lang === "arabic"
            ? "امتلاك الكرة"
            : "Ball Possession"
        }
      />

      {/* Passes */}
      <MatchComparisonProgressBar
        percentage1={passesPercentage.percentage1}
        percentage2={passesPercentage.percentage2}
        value1={homePasses}
        value2={awayPasses}
        name={
          lang === "english"
            ? "Passes"
            : lang === "spanish"
            ? "Pases"
            : lang === "french"
            ? "Laissez-passer"
            : lang === "arabic"
            ? "يمر، يمرر، اجتاز بنجاح"
            : "Passes"
        }
      />
    </>
  );
};

export default MatchComparison;
